import React from 'react';
import whatsapp_img from '../../assets/whatsapp.webp'
import instagram_img from '../../assets/instagram.webp'
import youtube_img from '../../assets/youtube.webp'
import './whatsapp.css'

const Whatsapp = () => {
    return (
        <>
            <div className="whatsapp_float">
                <a href="https://wa.me/918595941055" target='blank'><img src={whatsapp_img} alt="social_media"  className='mt-2'/></a> <br />
                <a href="https://www.instagram.com/sharvaclinique?igsh=Mm05NHFrcnU5ZTF5" target='blank'><img src={instagram_img} alt="social_media" className='mt-2'/></a> <br />
                <a href="https://www.youtube.com/@ShharvaClinic" target='blank'><img src={youtube_img} alt="social_media" className='mt-2'/></a>
            </div>
        </>
    );
}

export default Whatsapp;
